<!-- Desktop View -->
<ng-container *appIsDesktop>
  @if (contactsList.length && !loading) {
    <div id="contactsList">
      <div id="contactsListContainer" class="contacts-list">
        @for (contact of contactsList; track contact; let index = $index) {
          <div>
            <ds-paper elevation="elevation_none" borderRadius="radius_S" outline="outlined" insidePaddingTop="top-spacing_L"
              insidePaddingBottom="bottom-spacing_L" insidePaddingLeft="left-spacing_L" insidePaddingRight="right-spacing_L">
              <div [id]="'contact-details-'+index" class="contact-details">
                <div [id]="'contactImage-'+index" class="img-container">
                  <img alt="contact" [src]="photoUrlList[contact.id]" />
                </div>
                <div [id]="'contactInfo-'+index" class="contact-info">
                  <div class="contact-header">
                    <div [id]="'contact-name-'+index">
                      <typography variant="mat-subtitle-1" weight="bold">
                        {{contact.lastName}}, {{contact.firstName}}
                      </typography>
                    </div>
                    @if (isOnline && canEdit) {
                      <div [id]="'contactsButton-'+index" class="actions">
                        <ds-button [id]="'deleteButton-'+index" variant="tertiary" type="icon-label" [label]="appStrings.button_delete"
                          (onClick)="deleteContact(contact.id)" icon="delete" iconStyle="material-icons-outlined" size="medium">
                        </ds-button>
                        <ds-button [id]="'editButton-'+index" variant="secondary" type="icon-label" [label]="appStrings.label_edit"
                          (onClick)="editContact(contact.id)" icon="edit" iconStyle="material-icons-outlined" size="medium">
                        </ds-button>
                      </div>
                    }
                  </div>
                  <ds-divider></ds-divider>
                  <div [id]="'infoRowPhone-'+index" class="info-row">
                    <div [id]="'phoneInfo-'+index" class="info">
                      <typography class="label" variant="mat-caption-1" weight="regular">{{appStrings.contacts_phone}}</typography>
                      <typography variant="mat-body-2" weight="bold">{{contact?.phoneNumber || '-'}}</typography>
                    </div>
                    <div [id]="'emailInfo-'+index" class="info">
                      <typography class="label" variant="mat-caption-1" weight="regular">{{appStrings.contacts_email}}</typography>
                      <typography variant="mat-body-2" weight="bold">
                        @if (contact.email) {
                          <ds-link linkRef="mailto:{{contact.email}}">{{contact.email}}</ds-link>
                        }
                        @if (!contact.email) {
                          -
                        }
                      </typography>
                    </div>
                  </div>
                  <div [id]="'addressInfo-'+index" class="info">
                    <typography class="label" variant="mat-caption-1" weight="regular">{{appStrings.contacts_address}}</typography>
                    <typography variant="mat-body-2" weight="bold" class="contact-address">{{contact?.addressText || '-'}}</typography>
                  </div>
                  <div [id]="'infoRowDeptTitle-'+index" class="info-row">
                    <div [id]="'departmentInfo-'+index" class="info">
                      <typography class="label" variant="mat-caption-1" weight="regular">{{appStrings.contacts_department || 'Department'}}</typography>
                      <typography variant="mat-body-2" weight="bold">{{contact?.department || '-'}}</typography>
                    </div>
                    <div [id]="'titleInfo-'+index" class="info">
                      <typography class="label" variant="mat-caption-1" weight="regular">{{appStrings.contacts_title || 'Title'}}</typography>
                      <typography variant="mat-body-2" weight="bold">{{contact?.title || '-'}}</typography>
                    </div>
                  </div>
                  <div [id]="'last-note-'+index" class="info">
                    <typography class="label" variant="mat-caption-1" weight="regular">
                      {{appStrings.contacts_lastNote}} {{contact?.lastNote?.date.length ? (' - ' + (contact?.lastNote?.date | date:dateTimeFormat)) : ''}}
                    </typography>
                    <typography (click)="toggle($event)" variant="mat-body-2" weight="bold" class="note-text collapsed">
                      {{contact?.lastNote?.detail || '-'}}
                    </typography>
                  </div>
                </div>
              </div>
            </ds-paper>
          </div>
        }
      </div>
    </div>
  }
</ng-container>

<!-- Mobile View -->
<ng-container *appIsMobile>
  @if (contactsList.length && !loading) {
    <div id="contactsList" class="mobile">
      <div id="contactsListContainer" class="contacts-list">
        @for (contact of contactsList; track contact; let index = $index) {
          <mat-expansion-panel class="mobile-card tall blue-border" [id]="'contact-card-'+index">
            <mat-expansion-panel-header class="panel-header">
              <mat-panel-description>
                <div class="mobile-card-content">
                  <div class="contact-name">
                    <typography variant="mat-subtitle-1" weight="bold" class="contact-name">
                      {{contact.lastName}}, {{contact.firstName}}
                    </typography>
                  </div>
                  <div class="divider">
                    <ds-divider></ds-divider>
                  </div>
                  <div class="contact-details">
                    <div [id]="'contactImage-mobile-'+index" class="img-container">
                      <img alt="contact" [src]="photoUrlList[contact.id]" />
                    </div>
                    <div class="side-contact-details">
                      <div class="row">
                        <div [id]="'phoneInfo-mobile-'+index" class="column">
                          <typography class="label" variant="mat-caption-1" weight="regular">{{appStrings.contacts_phone}}</typography>
                          <typography variant="mat-body-2" weight="bold">{{contact?.phoneNumber || '-'}}</typography>
                        </div>
                      </div>
                      <div class="row">
                        <div [id]="'emailInfo-mobile-'+index" class="column">
                          <typography class="label" variant="mat-caption-1" weight="regular">{{appStrings.contacts_email}}</typography>
                          <typography variant="mat-body-2" weight="bold">
                            @if (contact.email) {
                              <ds-link linkRef="mailto:{{contact.email}}">{{contact.email}}</ds-link>
                            }
                            @if (!contact.email) {
                              -
                            }
                          </typography>
                        </div>
                      </div>
                      <div class="row">
                        <div [id]="'addressInfo-mobile-'+index" class="column">
                          <typography class="label" variant="mat-caption-1" weight="regular">{{appStrings.contacts_address}}</typography>
                          <typography variant="mat-body-2" weight="bold">{{contact?.addressText || '-'}}</typography>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="expanded-only">
                    <div class="divider">
                      <ds-divider></ds-divider>
                    </div>
                    <div class="row two-columns">
                      <div [id]="'departmentInfo-mobile-'+index" class="column">
                        <typography class="label" variant="mat-caption-1" weight="regular">{{appStrings.contacts_department || 'Department'}}</typography>
                        <typography variant="mat-body-2" weight="bold">{{contact?.department || '-'}}</typography>
                      </div>
                      <div [id]="'titleInfo-mobile-'+index" class="column">
                        <typography class="label" variant="mat-caption-1" weight="regular">{{appStrings.contacts_title || 'Title'}}</typography>
                        <typography variant="mat-body-2" weight="bold">{{contact?.title || '-'}}</typography>
                      </div>
                    </div>
                  </div>
                  @if (contact?.lastNote?.detail) {
                    <div class="divider">
                      <ds-divider></ds-divider>
                    </div>
                  }
                  @if (contact?.lastNote?.detail) {
                    <div class="row">
                      <div [id]="'last-note-mobile-'+index" class="column">
                        <typography class="label" variant="mat-caption-1" weight="regular">
                          {{appStrings.contacts_lastNote}} - {{contact?.lastNote?.date.length ? (contact?.lastNote?.date | date:dateTimeFormat) : ''}}
                        </typography>
                        <typography (click)="toggle($event)" variant="mat-body-2" weight="bold" class="note-text collapsed">
                          {{contact?.lastNote?.detail || '-'}}
                        </typography>
                      </div>
                    </div>
                  }
                </div>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="divider">
              <ds-divider></ds-divider>
            </div>
            @if (isOnline && canEdit) {
              <div [id]="'contactsButton-mobile-'+index" class="card-actions">
                <ds-button
                  [id]="'editButton-mobile-'+index"
                  type="secondary"
                  variant="label-icon"
                  [label]="appStrings.label_edit"
                  (onClick)="editContact(contact.id)"
                  icon="edit"
                  iconStyle="material-icons-outlined"
                  size="medium">
                </ds-button>
                <ds-button
                  [id]="'deleteButton-mobile-'+index"
                  type="tertiary"
                  variant="label-icon"
                  [label]="appStrings.button_delete"
                  (onClick)="deleteContact(contact.id)"
                  icon="delete"
                  iconStyle="material-icons-outlined"
                  size="medium">
                </ds-button>
              </div>
            }
          </mat-expansion-panel>
        }
      </div>
    </div>
  }
</ng-container>

@if (!contactsList.length && !loading) {
  <div id="emptyContactsState" class="empty">
    <typography id="emptyContactsMessage" variant="mat-headline-6" weight="regular">{{appStrings.contacts_noContactsYet}}</typography>
  </div>
}

@if (loading) {
  <div class="overlay full">
    <ds-progress-spinner id="accountsLoader"></ds-progress-spinner>
    <typography id="loadingMessage" class="text-center">{{appStrings.pleaseWait}}</typography>
  </div>
}

<ds-dialog
  [title]="dialogTitle"
  [description]="dialogText"
  [actionButtons]="dialogButtons"
  [open]="dialogOpen$">
</ds-dialog>
